import http from "../httpService";
import {getBaseUrl} from "../../config";

export const submitAgentReport = (data, paginate) => {

  if (!paginate) {
    return http.post(
      `${getBaseUrl()}/agent_report`,
      data
    );
  }
  return http.post(
    `${getBaseUrl()}/agent_report?${paginate}`,
    data
  );
};
